/**
 * Mediatabs component. It displays photospanel, stickerspanel, backgroundspanel, layoutspanel and texts panels.
 * @constructor editor.mediatabs.MediaTabs
 * @param {object} dom DOM
 */

fx.ns("desktop.calendar", class MediaTabs extends fx.Component {

	constructor(data) {
		super(data);
		this.assets = fx.get("assets");

		this.listenUpdates(data.photos);

		this.effect = "hslidein";
	}

	get currentArea() {
		return this._currentArea;
	}

	set currentArea(val) {
		this._currentArea = val;

		if (this.layoutPanel)
			this.layoutPanel.currentArea = this.currentArea;
	}

	isCreating() {
		return fx.get("mode") == "creating";
	}


	create() {
		super.create();

		this.tabs = new fx.components.TabsHorizontal();

		this.photoPanel = new desktop.common.panels.PhotosPanel(this.data, { automaticPlacingDisabled: true, filtersDisabled: true });
        this.tabs.addTab(fx.text("Photos"), this.assets.PhotoTab, this.photoPanel);

		this.layoutPanel = new desktop.common.panels.LayoutsPanel(this.data, new filters.LayoutCalendarFilter(), { maxRowHeight: 200 });
        this.tabs.addTab(fx.text("Modèles"), this.assets.LayoutTab, this.layoutPanel);

		this.stickerPanel = new desktop.common.panels.StickersPanel(this.data, { shapes: fx.get("isAdmin") });
        this.tabs.addTab(fx.text("Stickers"), this.assets.StickerTab, this.stickerPanel);

		//this.backgroundPanel = new desktop.common.panels.BackgroundsPanel(  this.data );
		//this.tabs.addTab(fx.text("Fonds"), this.assets.BackgroundTab, this.backgroundPanel);

        if (fx.get("isAdmin"))
        {
            this.textPanel = new desktop.common.panels.TextsPanel( this.data );
            this.tabs.addTab(fx.text("Textes"), this.assets.TextTab, this.textPanel);
        }
		
        if (!this.data.creation.isDesk) {
			this.calendarEventsPanel = new desktop.calendar.panels.CalendarEventsPanel(this.data);
			this.tabs.addTab(fx.text("Événements"), this.assets.EventsTab, this.calendarEventsPanel);
		}

		if (fx.get("app") != "config" && this.isCreating())
			this.tabs.selectTab(this.layoutPanel);

		this.addChild(this.tabs, { width: "100%", height: "100%" });
	}

	onReady() {
		super.onReady();
	}

});
